export type PaymentFormMessages = {
  beneficiaryAccountLabel: string;
  operationTypeLabel: string;
  pixAddressKeyLabel: string;
  pixAddressKeyTypeLabel: string;
  descriptionLabel: string;
  amountLabel: string;
  modalTitle: string;

  errorRequiredBeneficiaryAccount: string;
  errorRequiredOperationType: string;
  errorRequiredAmount: string;
  errorAmountOverBalance: string;
  errorRequiredPixAddressKey: string;
  errorRequiredPixAddressKeyType: string;
  errorAmountMustBeGreaterThanZero: string;

  loadingText: string;
  noOptionsItems: string;

  cancelButtonLabel: string;
  confirmButtonLabel: string;

  errorTitleLoadingCustomer: string;
  errorTitleLoadingAccounts: string;
  errorTitleLoadingBalance: string;
};

export const PAYMENT_FORM_MESSAGES: PaymentFormMessages = {
  beneficiaryAccountLabel: "Conta Beneficiária",
  operationTypeLabel: "Tipo de Operação",
  pixAddressKeyLabel: "Chave PIX (CPF/CNPJ)",
  pixAddressKeyTypeLabel: "Tipo de PIX",
  descriptionLabel: "Descrição",
  amountLabel: "Valor da Transferência",
  modalTitle: "Transferência",

  // Mensagens de erro
  errorRequiredBeneficiaryAccount: "Selecione uma conta beneficiária.",
  errorRequiredOperationType: "Selecione o tipo de operação.",
  errorRequiredAmount: "Informe um valor para transferência.",
  errorAmountOverBalance: "O valor informado excede o saldo disponível.",
  errorRequiredPixAddressKey: "Informe a chave PIX.",
  errorRequiredPixAddressKeyType: "Informe o tipo de chave PIX.",
  errorAmountMustBeGreaterThanZero: "O valor deve ser maior que zero.",

  loadingText: "Carregando",
  noOptionsItems: "Nenhuma conta encontrada",

  cancelButtonLabel: "Cancelar",
  confirmButtonLabel: "Confirmar",

  errorTitleLoadingCustomer: "Erro ao carregar o cliente",
  errorTitleLoadingAccounts: "Erro ao carregar contas bancárias",
  errorTitleLoadingBalance: "Erro ao carregar saldo",
};
